import React, {useCallback} from 'react';
import {Stripe} from 'components/customer/Confirmation/Gateways/Stripe';
import {GatewayCode} from 'components/manufacturer/Payments/entity/Gateway';
import {Gateway} from 'components/customer/Confirmation/Gateways/Stripe/entity/Gateway';

export const useRenderGateway = () => {
    const renderPaymentGatewayElements = useCallback((gateway: Gateway) => {
        switch (gateway.name) {
            case GatewayCode.STRIPE:
                return <Stripe publishableKey={gateway.publishable_key} />;

            case GatewayCode.PAYPAL:
            default:
                return null;
        }
    }, []);

    return {
        renderPaymentGatewayElements,
    };
};
